/**
 * Section definitions — id, title, mono eyebrow for the UI chrome.
 * Order here is the canonical form order; schema engine filters this list
 * against the classifier but preserves order.
 */
export const SECTIONS = [
    {
        id: 'applicant',
        title: 'Applicant information',
        eyebrow: 'SECTION_01 · APPLICANT',
    },
    {
        id: 'building',
        title: 'Building information',
        eyebrow: 'SECTION_02 · BUILDING',
    },
    {
        id: 'occupancy',
        title: 'Occupancy',
        eyebrow: 'SECTION_03 · OCCUPANCY',
    },
    {
        id: 'lifeSafety',
        title: 'Life safety & fire protection',
        eyebrow: 'SECTION_04 · LIFE_SAFETY',
    },
    {
        id: 'security',
        title: 'Security',
        eyebrow: 'SECTION_05 · SECURITY',
    },
    {
        id: 'maintenance',
        title: 'Maintenance & operations',
        eyebrow: 'SECTION_06 · MAINTENANCE',
    },
    {
        id: 'parking',
        title: 'Parking & transportation',
        eyebrow: 'SECTION_07 · PARKING',
    },
    {
        id: 'recreation',
        title: 'Recreational facilities',
        eyebrow: 'SECTION_08 · RECREATION',
    },
    {
        id: 'commercialTenants',
        title: 'Commercial tenants',
        eyebrow: 'SECTION_09 · COMMERCIAL',
    },
    {
        id: 'subcontractors',
        title: 'Subcontractors',
        eyebrow: 'SECTION_10 · SUBCONTRACTORS',
    },
    {
        id: 'generalLiability',
        title: 'General liability exposure',
        eyebrow: 'SECTION_11 · GL',
    },
    {
        id: 'workersComp',
        title: 'Workers compensation',
        eyebrow: 'SECTION_12 · WORKERS_COMP',
    },
    {
        id: 'excessUmbrella',
        title: 'Excess / umbrella',
        eyebrow: 'SECTION_13 · EXCESS',
    },
    {
        id: 'lossHistory',
        title: 'Loss history & claims',
        eyebrow: 'SECTION_14 · LOSSES',
    },
    {
        id: 'review',
        title: 'Review & submit',
        eyebrow: 'SECTION_15 · REVIEW',
    },
];
//# sourceMappingURL=sections.js.map